module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/Gift@2x-329e64d5c92ad48201657eab6d3b9b56.jpg";